import { FC, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { ToastContext } from "src/context/toastContext";
import useFetch from "src/hooks/useFetch";

import { APIEndpoints } from "src/types/apiTypes";
import { ToastTypes } from "src/types";
import { AddNonCaseNoteProps, saveNoteApiResponseType } from "./types";
import ReactInputMask from "react-input-mask";
import DatePicker from "react-datepicker";



const AddNonCaseNote: FC<AddNonCaseNoteProps> = ({ patientName, isModalVisible, hideModal,refreshListing}): JSX.Element => {
  
  const { patientId } = useParams();
  const [noteDate, changeNoteDate] = useState<string>("");
  const [notes, setNote] = useState<string>('');

  const { data: saveNoteData, mutate: saveNoteMutate, error: saveNoteError } = useFetch<saveNoteApiResponseType>(APIEndpoints.SAVE_NOTE, {}, {},false)
  const { showToast } = useContext(ToastContext);
  const [treatmentDate, changeTreatmentDate] = useState<Date | null>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isInvalid, setInvalidStatus] = useState<boolean>(false);

  

  const saveNotes = () => {
    const requestBody = {
      "ref_id": patientId, // case id, wrt case
      "ref_type": "Case", // always this
      "description": notes,
      "note_date": noteDate || (treatmentDate ? (new Date(treatmentDate).toISOString().split("T")[0]).split("T")[0] : new Date())
    }
    saveNoteMutate(requestBody)
  };

  useEffect(() => {
    if (saveNoteData || saveNoteError) {
      hideModal()
      if(saveNoteData){
        const { code } = saveNoteData;
        if (code === 200) {
          showToast([`Notes Save Successfully`], ToastTypes.SUCCESS);
          refreshListing(saveNoteData.data.description)
        }
      }
    }
    return(()=>{
      setNote('')
      changeNoteDate('')
      //changeTreatmentDate(null);
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveNoteData, saveNoteError]);

  return (
    <div
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''} loader-index`}
      id="exampleModal"
      tabIndex={-1}
      data-bs-backdrop="true"
      aria-hidden="true"
      onClick={hideModal}
    >
      <div className="modal-dialog modal-lg" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="modal-title" id="exampleModalLabel">
              Add Non-Case Treatment for patient {patientName}
            </h3>
            <button type="button" className="btn-close" aria-label="Close" onClick={hideModal}></button>
          </div>

          <div className="modal-body">

            <div className="row my-2 align-items-center">
              <p>This will add a treatment date for a patient not attached to a case. If you are entering a treatment
                related to a specific case, please use the next steps on that case.</p>
            </div>

            <div className="row my-2 align-items-center">
              <div className="col-3 text-end">
                <label htmlFor="noteDate" className="form-label mb-0">Date</label>
              </div>
              <div className="col-7">
                <DatePicker
                  selected={treatmentDate}
                  onChange={(date) => {changeTreatmentDate(date)
                     //changeNoteDate(date)
                  }}
                  dateFormat="MM/dd/yyyy" // Altered line
                  className={`form-control ${isInvalid ? "is-invalid" : ""}`}
                  placeholderText="mm/dd/yyyy" // Altered line
                  showMonthDropdown
                  showYearDropdown
                  customInput={
                    <ReactInputMask mask="99/99/9999">
                      {(inputProps: {}) => <input {...inputProps} />}
                    </ReactInputMask>
                  }
                  // maxDate={new Date()} // Restrict future dates
                  wrapperClassName="w-100"
                />
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary m-0"
              data-bs-dismiss="modal"
              onClick={saveNotes}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNonCaseNote;
